import { api } from "./api";

export const bookingService = {
    create: async (data) => {
        return api.post("/bookings", data);
    },
    getById: async (id) => {
        return api.get(`/bookings/${id}`);
    }
};
